import Component from './tour-controller';

export default Component;